import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import { Tumbler } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { TestBem } from '../../../service/TestBem';
import { ButtonDecorator } from '../../ButtonDecorator/ButtonDecorator';

import './PhrasesSelectorGenerateControls.css';
import * as keyset from './PhrasesSelectorGenerateControls.i18n';

const i18n = i18nFactory(keyset);

export interface PhrasesSelectorGenerateControlsProps {
    isGenerateDisabled: boolean;
    isExcludePhrases: boolean;
    generateButtonText: string;
    className?: string;
    onGenerate: () => void;
    onExcludePhrasesToggle: () => void;
}

const BLOCK = 'phrases-selector-generate-controls';

export const PhrasesSelectorGenerateControls = ({
    className,
    generateButtonText,
    isGenerateDisabled,
    isExcludePhrases,
    onGenerate,
    onExcludePhrasesToggle
}: PhrasesSelectorGenerateControlsProps) => (
    <div className={classNames(Bem.cls(BLOCK), className)}>
        <ButtonDecorator
            disabled={isGenerateDisabled}
            cls={classNames(Bem.cls(BLOCK, 'generate-button'), TestBem.cls(BLOCK, 'generate-button'))}
            size="n"
            theme="normal"
            text={generateButtonText}
            onClick={onGenerate}
        />
        <div className={Bem.cls(BLOCK, 'exclude-phrases')}>
            <Tumbler
                cls={classNames(
                    Bem.cls(BLOCK, 'exclude-phrases-tumbler'),
                    TestBem.cls(BLOCK, 'exclude-phrases-tumbler')
                )}
                theme="normal"
                view="default"
                size="s"
                checked={isExcludePhrases}
                onChange={onExcludePhrasesToggle}
            >
                <Tumbler.On id="exclude-phrases" side="right" text={i18n('exclude-phrases')}>
                    {i18n('exclude-phrases')}
                </Tumbler.On>
            </Tumbler>
        </div>
    </div>
);
